import List from '@/pages/admin/quoteTemplates/List.vue';
import New from '@/pages/admin/quoteTemplates/New.vue';
import Edit from '@/pages/admin/quoteTemplates/Edit.vue';
import handlePaginationRouteProps from '@/utils/handlePaginationRouteProps.js';

export default [
  {
    path: 'quote_templates',
    name: 'quote-templates',
    component: List,
    props: handlePaginationRouteProps,
  },
  {
    path: 'quote_templates/new',
    name: 'new-quote-template',
    component: New,
  },
  {
    path: 'quote_templates/:id(\\d+)',
    name: 'quote-template',
    component: Edit,
  },
];
